import form from "./schemas/form";
import validations from "./schemas/validations";
import initialValues from "./schemas/initialValues";
import { useState } from "react";
import axios from "axios";
import { API_URL } from "../../../config";
import jsonToFormData from "json-form-data";
import {storeProductService} from "../../../services/productService";

const useNewProduct = () => {
    const { formId, formField } = form;

    const [isLoading, setIsLoading] = useState(false);

    const [snackbarConfig, setSnackbarConfig] = useState({
        color: 'info',
        title: '',
        message: '',
        icon: 'notifications'
    });

    const [show, setShow] = useState(false);
    const toggleSnackbar = () => setShow(!show);

    const handleSubmit = async (values, actions) => {

        try {

            // Post data to API
            await storeProductService(values);

            actions.resetForm();

            setSnackbarConfig({
                message: 'Producto registrado exitosamente',
                icon: 'check_circle',
                title: 'Productos',
                color: 'success'
            });

            setShow(true);

        } catch (error) {
            setSnackbarConfig({
                message: error.response.data.message,
                icon: 'cancel',
                title: 'Productos',
                color: 'warning'
            });

            setShow(true);
        }

        actions.setSubmitting(false);

    };

    return {
        validations,
        formId,
        formField,
        isLoading,
        show,
        initialValues,
        snackbarConfig,
        handleSubmit,
        toggleSnackbar
    };
};

export default useNewProduct;
